export enum PromoPlanErrorCode {
  ActivePlanNoEndDate = 'ActivePlanNoEndDate',
  WindowOverlap = 'WindowOverlap',
  ScheduledPlanAlreadyExists = 'ScheduledPlanAlreadyExists',
  NewPlanOverlapsScheduledPlan = 'NewPlanOverlapsScheduledPlan',
  PlanNotFound = 'PlanNotFound',
  PlanAlreadyApplicable = 'PlanAlreadyApplicable',
  PlanNotYetActive = 'PlanNotYetActive',
  PlanAlreadyEnded = 'PlanAlreadyEnded',
}
